import { render, staticRenderFns } from "./ComponentDataLoader.vue?vue&type=template&id=46642cb2&scoped=true&"
import script from "./ComponentDataLoader.vue?vue&type=script&lang=js&"
export * from "./ComponentDataLoader.vue?vue&type=script&lang=js&"
import style0 from "./ComponentDataLoader.vue?vue&type=style&index=0&id=46642cb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46642cb2",
  null
  
)

export default component.exports